import { render, staticRenderFns } from "./store-shipping.vue?vue&type=template&id=a9d22f72"
import script from "./store-shipping.vue?vue&type=script&lang=js"
export * from "./store-shipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports